function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M96.87,88.395L74.507,66.029c11.678-15.836,10.307-38.56-3.913-52.779C62.933,5.592,52.75,1.374,41.92,1.374  c-10.831,0-21.013,4.218-28.669,11.876C5.592,20.91,1.374,31.091,1.374,41.92c0,10.83,4.218,21.012,11.877,28.673  c7.657,7.659,17.839,11.877,28.671,11.877c8.766,0,17.167-2.797,24.115-7.956l22.358,22.354c1.132,1.133,2.637,1.756,4.237,1.756  c1.605,0,3.113-0.627,4.232-1.751c1.134-1.131,1.759-2.636,1.76-4.238S98.002,89.527,96.87,88.395z M41.92,13.359  c7.628,0,14.8,2.971,20.196,8.367c5.385,5.384,8.351,12.556,8.351,20.194s-2.966,14.811-8.352,20.196  c-5.394,5.395-12.566,8.366-20.195,8.366c-7.628,0-14.8-2.971-20.196-8.366c-5.395-5.393-8.366-12.565-8.366-20.196  c0-7.628,2.971-14.8,8.366-20.194C27.121,16.331,34.293,13.359,41.92,13.359z"
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), React.createElement("g", null, React.createElement("g", {
    transform: "translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)",
    style: {
      fill: "#000000"
    }
  }, React.createElement("svg", _extends({
    fill: "#000000",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.41d01f07.svg";
export { ForwardRef as ReactComponent };